<template>
    <Modal
        :title="stage === 'input' ? $t('popup.examCancellation.suggestTitle') : $t('popup.examCancellation.title')"
        with-close-action
        @close="close"
    >
        <div v-if="stage === 'input'">
            <InputContainer class="flex flex-col items-center justify-center">
                <div>
                    <VueDatePicker
                        v-model="selectedDate"
                        inline
                        auto-apply
                        :enable-time-picker="false"
                        @date-update="
                            () => {
                                error = null;
                            }
                        "
                    />
                </div>
            </InputContainer>

            <InputContainer
                :label="$t('popup.examCancellation.textareaLabel')"
                no-feedback
            >
                <InputTextarea
                    v-model="message"
                    :placeholder="$t('popup.examCancellation.textareaPlaceholder')"
                    class="max-h-40"
                    no-resize
                ></InputTextarea>
            </InputContainer>

            <div class="flex items-center justify-center mt-2">
                <span
                    v-if="error"
                    class="text-red-500"
                    v-text="error"
                ></span>
            </div>
        </div>

        <template #actions>
            <!-- native modifier has been removed, please confirm whether the function has been affected  -->
            <BtnCta
                v-if="stage === 'confirm'"
                variant="secondary"
                class="flex-1"
                :label="$t('common:no')"
                @click="onNo()"
            />
            <!-- native modifier has been removed, please confirm whether the function has been affected  -->
            <BtnCta
                v-if="stage === 'confirm'"
                variant="secondary"
                class="flex-1"
                :label="$t('common:yes')"
                @click="close()"
            />
            <BtnCta
                v-if="stage === 'input'"
                variant="secondary"
                class="flex-1"
                :label="$t('common:submit')"
                :disabled="progress"
                @click="onSubmit()"
            />
        </template>
    </Modal>
</template>

<script>
import Modal from '@components/Modal';
import ModalMixin from '@mixins/modalMixin';
import { sendExamReport } from '@/api/backend/course';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

export default {
    name: 'ModalExamDateConfirmation',
    components: {
        VueDatePicker,
        Modal,
    },
    extends: ModalMixin,
    i18nOptions: {
        namespaces: ['course'],
    },
    props: {
        courseId: {
            type: Number,
            required: true,
        },
        confirmedExamDate: {
            type: Date,
            default: undefined,
        },
    },
    data: () => ({
        message: null,
        stage: 'confirm',
        selectedDate: new Date(Date.now()),
        error: null,
        progress: false,
    }),
    methods: {
        parseDate(dateString) {
            const [day, month, year] = dateString.split('.');
            return new Date(`${year}-${month}-${day}`);
        },
        formatDate(date) {
            const newDate = new Date(date);
            const day = String(newDate.getDate()).padStart(2, '0');
            const month = String(newDate.getMonth() + 1).padStart(2, '0');
            const year = newDate.getFullYear();
            return `${day}.${month}.${year}`;
        },
        onNo() {
            if (this.confirmedExamDate) {
                this.selectedDate = this.parseDate(this.confirmedExamDate);
            }
            this.stage = 'input';
        },
        onSubmit() {
            if (!this.selectedDate || this.formatDate(this.selectedDate) === this.confirmedExamDate) {
                this.error = this.$t('examWidget.error_empty');
                return;
            }
            if (this.selectedDate < new Date(Date.now())) {
                this.error = this.$t('examWidget.error_date');
                return;
            }
            this.progress = true;
            sendExamReport(this.courseId, this.formatDate(this.selectedDate), this.message)
                .then((response) => {
                    if (response.status === 200) {
                        this.close();
                        this.$store.dispatch('flashMessages/showSuccess', {
                            content: this.$t('popup.examCancellation.submitMessage'),
                        });
                    }
                })
                .finally(() => {
                    this.progress = false;
                });
        },
    },
};
</script>
